/**
 * The generated client's answers, as TanStack Query wants them: the data, or a
 * thrown `ApiError` with the server's reason (rule 2 of `frontend.md`).
 */

export class ApiError extends Error {
  constructor(
    readonly status: number,
    readonly detail: string,
  ) {
    super(detail);
    this.name = "ApiError";
  }
}

/** FastAPI's `detail`: a sentence, or a 422's list of field errors. */
function detailOf(error: unknown): string | null {
  if (typeof error !== "object" || error === null || !("detail" in error)) return null;
  const { detail } = error as { detail: unknown };
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail)) {
    return detail
      .map((d) => (typeof d === "object" && d !== null && "msg" in d ? String(d.msg) : String(d)))
      .join("; ");
  }
  return null;
}

interface Answer<D> {
  data?: D;
  error?: unknown;
  response: Response;
}

/** The data of a call that succeeded; an `ApiError` for one that did not. */
export async function ok<D>(call: Promise<Answer<D>>): Promise<D> {
  const { data, error, response } = await call;
  if (!response.ok) throw new ApiError(response.status, detailOf(error) ?? response.statusText);
  return data as D;
}

/** Why it failed, in words for the person. */
export function reason(error: unknown): string {
  if (error instanceof ApiError) return error.detail;
  if (error instanceof Error) return error.message;
  return String(error);
}
